module.exports = __webpack_public_path__ + "img/羊耳朵.b04e620f.gif";